import { Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Services from "./pages/Services";
import WhyChooseUs from "./pages/WhyChooseUs";
import ServicePage from "./pages/services/ServicePage";
import Home1 from './pages/HomeSection'
import About1 from './pages/AboutSection'
import Blogs from './pages/BlogsSection/BlogListing'
import BlogDetail from './pages/BlogsSection/BlogDetail'
function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      offset: 100,
    });
  }, []);
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home1 />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About1 />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServicePage />} />
        <Route path="/whychooseus" element={<WhyChooseUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
